export default {"src":"/_next/static/media/0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a.6d8b1f8f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};